import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ReferenceLine,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { GRR_RATE } from "./exampleData";
import { BORDER, MUTED, MUTED_FG, tooltipStyle, xAxisProps, yAxisProps } from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Gross Revenue Retention by month — the share of last period's MRR that survives
 * churn and contraction. Neutral bars under a 100% ceiling line, since GRR counts
 * only losses and can never exceed 100%.
 */
const GrrChart = () => (
  <MetricChartFrame
    caption="Gross retention holds in the high 80s to low 90s and never touches the 100% ceiling — because GRR counts only churn and contraction. A GRR below 85% means the revenue floor is leaking."
    chartType="Line"
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={GRR_RATE} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => `${v}%`} domain={[0, 100]} width={44} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [`${value}%`, "Gross retention"]}
      />
      <ReferenceLine
        y={100}
        stroke={MUTED_FG}
        strokeDasharray="4 4"
        label={{
          value: "Ceiling (100%)",
          position: "insideTopRight",
          fill: MUTED_FG,
          fontSize: 11,
        }}
      />
      <Bar dataKey="value" fill={MUTED} radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => `${v}%`}
          fontSize={11}
          fill={MUTED_FG}
        />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default GrrChart;
